import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import ids from 'Components/Worksheets/QestIds';
import { WorksheetRootComponent } from '../../Core/types';
import { PsdSieveAnalysisAstmC136Worksheet } from '../Astm/C136/PsdSieveAnalysisAstmC136Worksheet';
import { PsdAashtoTerminologyModifier } from './PsdSieveAnalysisAashtoTerminologyModifier';

const qestIds = [ids.psdSieveAnalysis.AASHTO_T_27.rev2020];

let PsdSieveAnalysisAashtoT27Worksheet: WorksheetRootComponent = () => (
  <PsdAashtoTerminologyModifier>
    <PsdSieveAnalysisAstmC136Worksheet />
  </PsdAashtoTerminologyModifier>
);

PsdSieveAnalysisAashtoT27Worksheet = withInjectedProps(PsdSieveAnalysisAashtoT27Worksheet);
PsdSieveAnalysisAashtoT27Worksheet.qestIds = qestIds;

export default PsdSieveAnalysisAashtoT27Worksheet;
export { PsdSieveAnalysisAashtoT27Worksheet };
